/*
  Formats a price in cents with the shop's money_format string, mirroring
  Shopify's money filter for the placeholder variants it supports. Loaded
  from layout/theme.liquid so the product page (capra-product.js) and the
  cart upsell modal (capra-cart-upsell.js) share it.
*/
window.capraFormatMoney = function capraFormatMoney(cents, format) {
  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const match = (format || '').match(placeholder);
  if (!match) return format || '';
  const group = (integer, separator) => integer.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  const whole = () => String(Math.round(cents / 100));
  const parts = () => (cents / 100).toFixed(2).split('.');
  let value;
  switch (match[1]) {
    case 'amount_no_decimals':
      value = group(whole(), ',');
      break;
    case 'amount_with_comma_separator': {
      const [integer, decimals] = parts();
      value = `${group(integer, '.')},${decimals}`;
      break;
    }
    case 'amount_no_decimals_with_comma_separator':
      value = group(whole(), '.');
      break;
    case 'amount_with_apostrophe_separator': {
      const [integer, decimals] = parts();
      value = `${group(integer, "'")}.${decimals}`;
      break;
    }
    case 'amount_no_decimals_with_space_separator':
      value = group(whole(), ' ');
      break;
    case 'amount_with_space_separator': {
      const [integer, decimals] = parts();
      value = `${group(integer, ' ')},${decimals}`;
      break;
    }
    default: {
      const [integer, decimals] = parts();
      value = `${group(integer, ',')}.${decimals}`;
    }
  }
  return format.replace(placeholder, value);
};
